export const SOCIAL_MEDIA_INTERACTIONS_FORMATTED_BASE =
  'notification.metrics.socialMediaInteractions'
export const SOCIAL_MEDIA_ICON_SIZE = 40
